export default "__VITE_ASSET__QyEjes8M__"